
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { MessageSquare, ArrowRight } from 'lucide-react';
import { PollShareSectionProps } from './types';
import ShareButton from '@/components/social/ShareButton';
import LikeButton from '@/components/social/LikeButton';
import { usePollSocialMetrics } from '@/hooks/usePollSocialMetrics';

const PollShareSection: React.FC<PollShareSectionProps> = ({ 
  poll, 
  showShareButtons = true, 
  variant = 'default' 
}) => {
  if (!showShareButtons) return null;
  
  // Skip for embedded variant
  if (variant === 'embedded') return null;
  
  // Get poll metrics
  const { metrics: socialMetrics } = usePollSocialMetrics(poll?.id);
  
  // Create shareable URL for the poll
  const pollUrl = poll.poll_number 
    ? `/polls/${poll.poll_number}` 
    : `/poll/${poll.id}`;
    
  return (
    <div className="flex flex-wrap justify-between items-center pt-3 border-t border-gray-100 dark:border-gray-800">
      <div className="flex items-center gap-2">
        <LikeButton 
          cardId={poll.id}
          initialLikes={socialMetrics?.likesCount || 0}
          showCount={true}
          size="sm"
          contentType="poll"
        />
        
        <Link to={`${pollUrl}#comments`}>
          <Button variant="outline" size="sm">
            <MessageSquare className="h-4 w-4 mr-1" />
            {socialMetrics?.commentsCount || 0}
          </Button>
        </Link>
        
        <ShareButton
          contentId={poll.id}
          contentType="poll"
          title={`Poll: ${poll.title}`}
          description={poll.description || ''}
          url={`${window.location.origin}${pollUrl}`}
          initialShares={socialMetrics?.sharesCount || 0}
          showCount={true}
          size="sm"
        />
      </div>
      
      <Link to={pollUrl}>
        <Button variant="ghost" size="sm" className="text-blue-600">
          View Details <ArrowRight className="ml-1 h-4 w-4" />
        </Button>
      </Link>
    </div>
  );
};

export default PollShareSection;
